<script setup lang="ts">
import { FeedbackMessage, FeedbackMessageState } from '@kiplin/web-common/design-system';
import RichTextEditorQuill from '@shared/common/form/application/component/rich-text/RichTextEditorQuill.vue';

const model = defineModel<string>({ required: true, default: () => '' });

const props = defineProps<{
  id?: string;
  label?: string;
  hint?: string;
  message?: string;
  error?: string;
  placeholder?: string;
  readonly?: boolean;
  disabled?: boolean;
}>();

function getFeedbackMessage(): string {
  return props.error ?? props.message ?? '';
}
</script>

<template>
  <div class="rich-text-input relative flex flex-col items-start">
    <div v-if="props.label || props.hint" class="mb-2 w-full">
      <div class="flex items-start justify-between gap-2">
        <p v-if="props.label" class="rich-text-input-label typo-subtitle1 text-black">
          {{ props.label }}
        </p>
      </div>
      <p v-if="props.hint" class="rich-text-input-hint mt-0.5 typo-text3 text-grey">
        {{ props.hint }}
      </p>
    </div>

    <RichTextEditorQuill
      :id="props.id"
      v-model="model"
      :placeholder="props.placeholder"
      :readonly="props.readonly"
      :disabled="props.disabled"
      :error="props.error"
    />

    <FeedbackMessage
      v-if="props.error || props.message"
      class="mt-2"
      :text="getFeedbackMessage()"
      :state="props.error ? FeedbackMessageState.Error : FeedbackMessageState.Default"
      :role="props.error ? 'alert' : undefined"
    />
  </div>
</template>
